/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Live_Caption_Youtube_Warning_BodyInputs */

const en_live_caption_youtube_warning_body = /** @type {(inputs: Live_Caption_Youtube_Warning_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Do not monitor audio through the YouTube player. YouTube latency can be 15-60 seconds, which will make captions drift out of sync.`)
};

const fr_live_caption_youtube_warning_body = /** @type {(inputs: Live_Caption_Youtube_Warning_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`N'écoutez pas le son via le lecteur YouTube. La latence de YouTube peut atteindre 15 à 60 secondes, ce qui risque de désynchroniser les sous-titres.`)
};

const de_live_caption_youtube_warning_body = /** @type {(inputs: Live_Caption_Youtube_Warning_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Audioausgabe sollte nicht über den YouTube-Player überwacht werden. Die Latenz bei YouTube kann 15–60 Sekunden betragen, wodurch die Untertitel asynchron werden.`)
};

const it_live_caption_youtube_warning_body = /** @type {(inputs: Live_Caption_Youtube_Warning_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non monitorare l'audio tramite il player di YouTube. La latenza di YouTube può variare dai 15 ai 60 secondi, causando una desincronizzazione dei sottotitoli.`)
};

const ru_live_caption_youtube_warning_body = /** @type {(inputs: Live_Caption_Youtube_Warning_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Не контролируйте звук через плеер YouTube. Задержка звука на YouTube может составлять от 15 до 60 секунд, из-за чего субтитры будут рассинхронизироваться.`)
};

const es_live_caption_youtube_warning_body = /** @type {(inputs: Live_Caption_Youtube_Warning_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No monitorices el audio a través del reproductor de YouTube. La latencia de YouTube puede ser de entre 15 y 60 segundos, lo que provocará que los subtítulos se desincronicen.`)
};

const zh_cn2_live_caption_youtube_warning_body = /** @type {(inputs: Live_Caption_Youtube_Warning_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请勿通过 YouTube 播放器监听音频。YouTube 的延迟可能为 15-60 秒，这会导致字幕与音频不同步。`)
};

const ja_live_caption_youtube_warning_body = /** @type {(inputs: Live_Caption_Youtube_Warning_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`YouTubeプレーヤーを通して音声をモニタリングしないでください。YouTubeの遅延は15～60秒程度になる場合があり、字幕が同期しなくなる可能性があります。`)
};

const hi_live_caption_youtube_warning_body = /** @type {(inputs: Live_Caption_Youtube_Warning_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`YouTube प्लेयर के माध्यम से ऑडियो मॉनिटर न करें। YouTube में 15-60 सेकंड का विलंब हो सकता है, जिससे कैप्शन का सिंक बिगड़ सकता है।`)
};

const pt_pt2_live_caption_youtube_warning_body = /** @type {(inputs: Live_Caption_Youtube_Warning_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não monitore o áudio pelo player do YouTube. A latência do YouTube pode ser de 15 a 60 segundos, o que fará com que as legendas fiquem dessincronizadas.`)
};

/**
* | output |
* | --- |
* | "Do not monitor audio through the YouTube player. YouTube latency can be 15-60 seconds, which will make captions drift out of sync." |
*
* @param {Live_Caption_Youtube_Warning_BodyInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const live_caption_youtube_warning_body = /** @type {((inputs?: Live_Caption_Youtube_Warning_BodyInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Live_Caption_Youtube_Warning_BodyInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_live_caption_youtube_warning_body(inputs)
	if (locale === "de") return de_live_caption_youtube_warning_body(inputs)
	if (locale === "it") return it_live_caption_youtube_warning_body(inputs)
	if (locale === "ru") return ru_live_caption_youtube_warning_body(inputs)
	if (locale === "es") return es_live_caption_youtube_warning_body(inputs)
	if (locale === "zh-CN") return zh_cn2_live_caption_youtube_warning_body(inputs)
	if (locale === "ja") return ja_live_caption_youtube_warning_body(inputs)
	if (locale === "hi") return hi_live_caption_youtube_warning_body(inputs)
	if (locale === "pt-PT") return pt_pt2_live_caption_youtube_warning_body(inputs)
	return en_live_caption_youtube_warning_body(inputs)
});